import React from "react";
import { PopupButton } from "react-calendly";

function OpenCalendly() {
  return (
    <PopupButton
      url="https://calendly.com/abircher31/30min"
      rootElement={document.getElementById("root")}
      text="Réserver En Ligne"
    />
  );
}

export default OpenCalendly;
